import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-creative";
import "swiper/css/navigation";
import { EffectCreative, Navigation, Autoplay } from "swiper/modules";
import { Box, Modal } from "@mui/material";
import Share from "../../../../../common/components/Share";
import ContactUsModal from "./ContactUsModal";
import LocateStoreModal from "./LocateStoreModal";
import CloudinaryAdvancedImage from "@common/utils/CloudinaryAdvancedImage";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
};

function Detail({ swiperData, name, description, brochure_url }) {
  const [shareOptionModal, setShareOptionModal] = useState(false);
  const [contactUsModal, setContactUsModal] = useState(false);
  const [locateStoreModal, setLocateStoreModal] = useState(false);
  const [sortedSwiperData, setSortedSwiperData] = useState([]);

  const handleOpenShareOptionModal = () => {
    setShareOptionModal(true);
  };

  const handleCloseShareOptionModal = () => {
    setShareOptionModal(false);
  };

  const handleOpenContactUsModal = () => {
    setContactUsModal(true);
  };

  const handleCloseContactUsModal = () => {
    setContactUsModal(false);
  };

  const handleOpenLocateStoreModal = () => {
    setLocateStoreModal(true);
  };

  const handleCloseLocateStoreModal = () => {
    setLocateStoreModal(false);
  };

  const [imageId, setImageId] = useState(null);

  useEffect(() => {
    swiperData?.sort((a, b) => b.isPrimary - a.isPrimary);
    const filteredData = swiperData?.filter((item) => item.isPrimary === true);
    setImageId(filteredData[0]?.imagePublicId);
    setSortedSwiperData(swiperData);
  }, [swiperData]);

  return (
    <>
      <div className="bs-collection-detail">
        <div className="bs-collection-detail__media-wrap">
          <Swiper
            grabCursor={true}
            loop={true}
            effect={"creative"}
            navigation={true}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
            }}
            creativeEffect={{
              prev: {
                shadow: true,
                translate: ["-20%", 0, -1],
              },
              next: {
                translate: ["100%", 0, 0],
              },
            }}
            speed={1100}
            modules={[EffectCreative, Navigation, Autoplay]}
            className="bs-collection-detail__swiper-container"
          >
            {sortedSwiperData.map((item, index) => {
              return (
                <SwiperSlide key={index}>
                  <CloudinaryAdvancedImage imagePublicId={item.imagePublicId} className="bs-collection-detail__image" type="original" />
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
        <div className="bs-collection-detail__info-wrap">
          <div className="bs-collection-detail__text-wrap">
            <h3 className="bs-collection-detail__title">{name}</h3>
            <div className="bs-collection-detail__info">
              <p className="bs-collection-detail__desc">{description}</p>
            </div>
          </div>
          <div className="bs-collection-detail__actions-container">
            <div className="bs-collection-detail__primary-actions">
              <div className="bs-collection-detail__action-wrap">
                <button
                  className="bs-btn bs-btn__btn-icon-solid"
                  onClick={handleOpenContactUsModal}
                >
                  <span className="bs-btn__icon icon icon-contact"></span>
                  <span className="bs-btn__btn-text">contact us</span>
                </button>
                <button
                  className="bs-btn bs-btn__btn-icon-solid"
                  onClick={handleOpenLocateStoreModal}
                >
                  <span className="bs-btn__icon icon icon-pin"></span>
                  <span className="bs-btn__btn-text">locate store</span>
                </button>
              </div>
            </div>

            <div className="bs-collection-detail__secondary-actions">
              <div className="bs-collection-detail__action-wrap">
                <button
                  className="bs-btn bs-btn__btn-icon-solid"
                  onClick={handleOpenShareOptionModal}
                >
                  <span className="bs-btn__icon icon icon-share"></span>
                  <span className="bs-btn__btn-text">share</span>
                </button>
                <a
                  href={brochure_url}
                  rel="noreferrer"
                  target="_blank"
                  className="bs-btn bs-btn__btn-icon-solid"
                >
                  <span className="bs-btn__icon icon icon-doc"></span>
                  <span className="bs-btn__btn-text">download brochure</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        open={shareOptionModal}
        onClose={handleCloseShareOptionModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="bs-modal bs-modal--typ-sm"
      >
        <Box className="bs-modal__wrapper" sx={style}>
          <div className="bs-modal__content">
            <button
              className="bs-modal__close"
              onClick={handleCloseShareOptionModal}
            >
              <span className="icon icon-simple-close"></span>
            </button>
            <Share imageId={imageId} name={name} />
          </div>
        </Box>
      </Modal>

      <ContactUsModal
        open={contactUsModal}
        onClose={handleCloseContactUsModal}
      />

      <LocateStoreModal
        open={locateStoreModal}
        onClose={handleCloseLocateStoreModal}
      />
    </>
  );
}

export default Detail;
